<template>
  <div class="monitor-container">
    <div class="header">
      <h2 class="title">环保在线监控系统</h2>
      <div class="time">{{ currentTime }}</div>
    </div>

    <div class="content">
      <!-- 左上角水质PH图表 -->
      <div class="chart-box">
        <div class="chart-title">废水PH</div>
        <div id="phChart" class="chart"></div>
      </div>

      <!-- 右上角气氧化物趋势图 -->
      <div class="chart-box">
        <div class="chart-title">氧气化物</div>
        <div id="gasChart" class="chart"></div>
      </div>

      <!-- 右侧报警信息列表 -->
      <div class="alarm-list">
        <div class="chart-title">报警信息</div>
        <el-table :data="alarmData" style="width: 100%" height="200">
          <el-table-column prop="type" label="类型" width="50">
            <template slot-scope="scope">
              <el-tag type="danger" size="mini">{{ scope.row.type }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="info" label="报警信息" />
          <el-table-column prop="time" label="时间" width="150" />
        </el-table>
      </div>

      <!-- 左下方实时数据表格 -->
      <div class="data-table">
        <div class="chart-title">实时数据</div>
        <el-table :data="realTimeData" style="width: 100%" size="mini">
          <el-table-column prop="id" label="序号" width="60" />
          <el-table-column prop="name" label="监测项" />
          <el-table-column prop="value" label="数值" />
          <el-table-column prop="time" label="时间" width="150" />
        </el-table>
      </div>

      <!-- 中下方PM2.5趋势图和报警分析 -->
      <div class="chart-box">
        <div class="chart-title">PM2.5</div>
        <div id="pm25Chart" class="chart"></div>
      </div>

      <!-- 报警分析饼图 -->
      <div class="chart-box">
        <div class="chart-title">报警分析</div>
        <div id="alarmPieChart" class="chart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'Monitor',
  data() {
    return {
      currentTime: '',
      // 报警信息数据
      alarmData: [
        { type: '警', info: '第一监测点发生异常', time: '2020-10-31 08:20' },
        { type: '警', info: '第一监测点发生异常', time: '2020-10-31 08:20' },
        { type: '警', info: '第一监测点发生异常', time: '2020-10-31 08:20' },
      ],
      // 实时数据
      realTimeData: [
        { id: 10, name: '溶解性总固体', value: '1.2', time: '2020-10-31 08:20' },
        { id: 11, name: 'PH传感器', value: '7.1', time: '2020-10-31 08:20' },
        { id: 12, name: '水体浊度', value: '1.1', time: '2020-10-31 08:20' },
        { id: 13, name: 'COD传感器', value: '120', time: '2020-10-31 08:20' },
        { id: 14, name: '氨氮', value: '0.1', time: '2020-10-31 08:20' },
        { id: 15, name: '电导率', value: '0.8', time: '2020-10-31 08:20' },
      ],
      charts: {}
    }
  },
  mounted() {
    this.initCharts()
    this.updateTime()
    // 定时更新时间
    setInterval(this.updateTime, 1000)
  },
  methods: {
    updateTime() {
      const now = new Date()
      this.currentTime = now.toLocaleString()
    },
    initCharts() {
      // 初始化PH柱状图
      this.charts.phChart = echarts.init(document.getElementById('phChart'))
      this.charts.phChart.setOption({
        grid: { top: 30, right: 20, bottom: 30, left: 40 },
        xAxis: {
          type: 'value',
          max: 80,
          axisLabel: {
            color: '#fff',
            fontSize: 14
          }
        },
        yAxis: {
          type: 'category',
          data: ['点5', '点4', '点3', '点2', '点1'],
          axisLabel: {
            color: '#fff',
            fontSize: 14
          }
        },
        series: [{
          type: 'bar',
          data: [45, 55, 35, 75, 45],
          barWidth: '40%',
          itemStyle: {
            color: function (params) {
              const colors = ['#ff6b81', '#45aaf2', '#26de81', '#fd9644', '#a55eea'];
              return colors[params.dataIndex];
            }
          },
          label: {
            show: true,
            position: 'right',
            color: '#fff',
            fontSize: 14
          }
        }]
      })

      // 初始化气氧化物趋势图
      this.charts.gasChart = echarts.init(document.getElementById('gasChart'))
      this.charts.gasChart.setOption({
        grid: { top: 30, right: 20, bottom: 30, left: 40 },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['07:45', '08:00', '08:15', '08:30', '08:45', '09:00'],
          axisLabel: {
            color: '#fff',
            fontSize: 14
          }
        },
        yAxis: {
          type: 'value',
          max: 200,
          axisLabel: {
            color: '#fff',
            fontSize: 14
          }
        },
        series: [{
          type: 'line',
          data: [120, 100, 150, 80, 70, 110],
          smooth: true,
          symbol: 'circle',
          symbolSize: 8,
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(24, 144, 255, 0.3)' },
              { offset: 1, color: 'rgba(24, 144, 255, 0)' }
            ])
          },
          lineStyle: {
            color: '#1890ff',
            width: 3
          },
          itemStyle: {
            color: '#1890ff',
            borderWidth: 2,
            borderColor: '#fff'
          },
          label: {
            show: true,
            position: 'top',
            color: '#fff',
            fontSize: 14,
            formatter: '{c}'
          }
        }]
      })

      // 初始化PM2.5趋势图
      this.charts.pm25Chart = echarts.init(document.getElementById('pm25Chart'))
      this.charts.pm25Chart.setOption({
        grid: { top: 30, right: 20, bottom: 30, left: 40 },
        xAxis: {
          type: 'category',
          data: ['10:29', '10:30', '11:01', '11:02', '11:03', '11:04', '11:05', '11:06'],
          axisLabel: {
            color: '#fff',
            fontSize: 14
          }
        },
        yAxis: {
          type: 'value',
          max: 40,
          axisLabel: {
            color: '#fff',
            fontSize: 14
          }
        },
        series: [{
          type: 'line',
          data: [25, 35, 12, 20, 30, 40, 10, 25],
          lineStyle: {
            color: '#1890ff',
            width: 2
          },
          itemStyle: {
            color: '#1890ff'
          },
          label: {
            show: true,
            position: 'top',
            color: '#fff',
            fontSize: 14
          },
          markLine: {
            data: [{ type: 'average', name: '平均值' }],
            label: {
              color: '#fff',
              fontSize: 14
            }
          }
        }]
      })

      // 初始化报警分析饼图
      this.charts.alarmPieChart = echarts.init(document.getElementById('alarmPieChart'))
      this.charts.alarmPieChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{b}'
        },
        legend: {
          orient: 'vertical',
          right: '5%',
          top: 'center',
          textStyle: {
            color: '#fff',
            fontSize: 12
          }
        },
        series: [{
          type: 'pie',
          radius: ['50%', '70%'],
          center: ['40%', '50%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderColor: '#001529',
            borderWidth: 2
          },
          label: {
            show: true,
            position: 'outside',
            formatter: '{c}%',
            color: '#fff',
            fontSize: 14
          },
          labelLine: {
            show: true,
            length: 15,
            length2: 10,
            lineStyle: {
              color: '#fff'
            }
          },
          data: [
            { value: 13, name: '火警', itemStyle: { color: '#ff6b81' } },
            { value: 23, name: '异常报警', itemStyle: { color: '#45aaf2' } },
            { value: 33, name: '运行监控', itemStyle: { color: '#26de81' } },
            { value: 43, name: '设备报警', itemStyle: { color: '#fd9644' } },
            { value: 23, name: '安全关闭', itemStyle: { color: '#a55eea' } }
          ]
        }]
      })
    }
  },
  beforeDestroy() {
    // 销毁图表实例
    Object.values(this.charts).forEach(chart => {
      chart && chart.dispose()
    })
  }
}
</script>

<style scoped>
.monitor-container {
  padding: 1vh;
  background-color: #001529;
  height: 98vh;
  color: #fff;
  display: flex;
  flex-direction: column;
}

.header {
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
  padding: 20px;
}

.title {
  font-size: 24px;
  margin: 0;
  color: #fff;
}

.time {
  font-size: 16px;
}

.chart-box {
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  padding: 15px;
}

.chart-title {
  font-size: 16px;
  margin-bottom: 15px;
  color: #fff;
}

.chart {
  height: 250px;
}

.wide {
  grid-column: span 2;
}

.alarm-list {
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  padding: 15px;
}

.data-table {
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  padding: 15px;
}

/* 自定义Element UI样式 */
/deep/ .el-table {
  background-color: transparent;
  color: #fff;
}

/deep/ .el-table th,
/deep/ .el-table tr {
  background-color: transparent;
}

/deep/ .el-table--border,
/deep/ .el-table--group {
  border-color: rgba(255, 255, 255, 0.1);
}

/deep/ .el-table td,
/deep/ .el-table th.is-leaf {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
</style>


// WEBPACK FOOTER //
// src/views/charts/monitor.vue